/**
 * 处方
 */
export default [
  {
    path: '/invoice',
    meta: {
      title: '处方检查'
    },
    component: () => import('../pages/invoice/index')
  },
  /**
   *
   * query
   * **** patid
   * **** patvisitid
   */
  {
    path: '/invoice/list',
    meta: {
      title: '处方检查'
    },
    component: () => import('../pages/invoice/list'),
    children: [
      {
        path: ':id',
        meta: {
          title: '处方检查'
        },
        component: () => import('../../src/pages/invoice/list-state.vue')
      }
    ]
  },
  /**
   * query
   * **** InvID
   * cache
   * **** invoiceDetail
   */
  {
    path: '/invoice/detail',
    meta: {
      title: '处方检查'
    },
    component: () => import('../pages/invoice/detail')
  },

  {
    name: 'inspection',
    path: '/invoice/detail/inspection/:i',
    component: () => import('../pages/invoice/inspection')
  },

  {
    path: '/invoice/succeed',
    meta: {
      title: '处方检查'
    },
    component: () => import('../pages/invoice/invioce-succeed')
  },
]



// WEBPACK FOOTER //
// ./src/router/invoice.js